import { type ReactNode } from 'react';
import { motion } from 'motion/react';

export interface FluidTabItem {
  id: string;
  label: string;
  icon: ReactNode;
}

interface FluidTabsProps {
  tabs: FluidTabItem[];
  activeId: string;
  onChange: (id: string) => void;
}

export default function FluidTabs({ tabs, activeId, onChange }: FluidTabsProps) {
  return (
    <div className="relative inline-flex items-center gap-1 rounded-full border border-stone-200 bg-stone-100/80 p-1">
      {tabs.map((tab) => {
        const isActive = activeId === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            className="group relative rounded-full px-4 py-2 outline-none"
          >
            {isActive && (
              <motion.div
                layoutId="user-mgmt-active-pill"
                transition={{ type: 'spring', stiffness: 280, damping: 25, mass: 0.8 }}
                className="absolute inset-0 rounded-full border border-white bg-white shadow-xs"
              />
            )}
            <motion.div
              animate={{ scale: isActive ? 1.03 : 1 }}
              transition={{ scale: { type: 'spring', stiffness: 300, damping: 15 } }}
              className={`relative z-10 flex items-center space-x-1.5 text-xs uppercase tracking-wider transition-colors duration-200 ${
                isActive ? 'font-bold text-brand-700' : 'font-bold text-stone-400 group-hover:text-stone-600'
              }`}
            >
              <span className="w-3.5 h-3.5 flex items-center justify-center shrink-0">{tab.icon}</span>
              <span className="whitespace-nowrap">{tab.label}</span>
            </motion.div>
          </button>
        );
      })}
    </div>
  );
}
